import DefaultValidation from '@/services/validations/DefaultValidation';
import { isNull, } from "@/functions/Util";

export default class UnidadeMedidaValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }

    validate(model, refs) {
        let validated = true;
        
        if (isNull(model.descricao)) {
            refs.descricaoInput.focusedOut = true;
            validated = false;
        }

        if (isNull(model.idunidademedidaerp)) {
            refs.idErpInput.focusedOut = true;
            validated = false;
        }
        
        return validated;
    }

}